import { splitPlacementPoints } from "../ties.js";
import type { Format, RoundResult } from "./types.js";
import { buildScoreMap, grossTotal, holeCount, scoringHoles } from "./util.js";

export const strokePlayGross: Format = {
  id: "strokePlayGross",
  name: "Stroke Play (Gross)",
  scope: "individual",
  uses: { pointTable: true },
  entry: "perPlayer",
  configSchema: { type: "object", properties: {} },
  perHoleSchema: null,

  score({ round, course, players, scores, onlyHoles }): RoundResult {
    const holes = scoringHoles(round, course, onlyHoles);
    const scoreMap = buildScoreMap(scores);

    const entries = players
      .map((p) => ({ id: p.id, value: grossTotal(scoreMap, p.id, holes) }))
      .filter((e): e is { id: string; value: number } => e.value != null);

    const points = splitPlacementPoints(entries, round.pointTable, { lowerIsBetter: true });
    const grossTotals: Record<string, number> = {};
    for (const e of entries) grossTotals[e.id] = e.value;

    const pointsRecord: Record<string, number> = {};
    for (const p of players) pointsRecord[p.id] = points.get(p.id) ?? 0;

    return { roundId: round.id, points: pointsRecord, grossTotal: grossTotals, provisional: Boolean(onlyHoles) };
  },

  describeRules(round, _players, course) {
    return [
      `Gross stroke play across ${holeCount(round, course)} holes. No handicap applied.`,
      `Points by finishing place: ${round.pointTable.join(", ")}. Ties split the points evenly.`,
    ];
  },
};
